import React from "react";
import {getData} from "./util";
import {observableStore} from "./obvStore";
import {LAUNCH_CONFIG, WALLETS} from "../Config/enum";

const sortCfg = {
    live: [22]
};
const avg = () => ({
    live: [],
    elect: [],
    fish: [],
    sport: [],
    rng: [],
    lottery: [],
    pvp: []
})
const isElect = /24|26|27/gi
export const gameTypeKeys = ['lottery', 'rng', 'live', 'fish', 'pvp', 'sport']
const generateGameCgh = (t) => (cfg = {}) => {
    const {id, product, status} = cfg;
    if (status) {
        gameTypeKeys.forEach(k => {
            if (cfg[k]) {
                const ext = (LAUNCH_CONFIG[k] || {})[id] || [];
                (t[k] = t[k] || []).push({
                    code: ext[0] || (k.toUpperCase() + 0 + id),
                    id: id,
                    name: ext[2] || product,
                    platform: ext[3] || 'html5,html5-desktop',
                    cls: ext[1] || (k + '-' + id)
                })
            }
        })
    }
}
const third = {
    cate: {},
    lottery: [],
    rng: [],
    live: [],
    fish: [],
    pvp: [],
    sport: [],
    game(type, id) {
        return (this[type] || []).find(a => a.id === id)
    },
    productValue: {},
    productType: {},
    initProducts(v) {
        v = v || [];
        if (!Array.isArray(v)) {
            v = Object.values(v)
        }
        const o = avg();
        const vv = {};
        const p = {};
        const w = [];

        const gm = {
            lottery: [],
            rng: [],
            live: [],
            fish: [],
            pvp: [],
            sport: []
        }
        v.forEach(generateGameCgh(gm))
        v.forEach(x => {
            const {id, product, status, product_type} = x;
            if (status) {
                p[id] = product;
                vv[id] = product_type;
                w.push(id);
                gameTypeKeys.forEach(k => {
                    if (x[k]) {
                        (o[k] = o[k] || []).push(id)
                        if (k === 'sport') {
                            isElect.lastIndex = 0;
                            if (isElect.test(id)) {
                                o.elect.push(id)
                            }
                        }
                    }
                });

            }
        });
        Object.keys(sortCfg).forEach(k => {
            const s = o[k];
            const d = sortCfg[k];
            if (s && s.length > 1) {
                s.sort(function (a, b) {
                    const x = d.indexOf(a)
                    const y = d.indexOf(b)
                    if (x !== y) return x > y ? -1 : 1
                    return 0;
                })
            }
        })
        this.productType = p;
        this.availableGames = o;
        this.wallets = w;
        this.productValue = vv;
        Object.assign(this, gm)
    },
    wallets: [],
    availableGames: avg(),
    getName(cate, code) {
        if (!cate) return code;
        const gs = this.cate[cate];
        if (!gs) {
            getData('@thirdGames', {
                product_type: 'ALL',
                game_type: cate
            })
        } else {
            const g = gs.find(({tcgGameCode}) => tcgGameCode === code);
            if (g) return g.gameName || code;
        }
        return code;
    }
};
export const thirdStore = observableStore('_thr', third);


export const walletStore = observableStore('_we', {
    name(p) {
        const {productType} = thirdStore
        const n = WALLETS[p] || productType[p] || '';
        return p === 'main' ? '主钱包' : n;
    },
    get wallets() {
        const {wallets} = thirdStore;
        return ['main'].concat(wallets.slice()).map(k => this.bls[k]).filter(a => a);
    },
    get totalBalance() {
        return Object.values(this.bls).map(a => a.balance).reduce((a, b) => (a || 0) + (b || 0), 0)
    },
    get loading() {
        return !!Object.values(this.bls).find(k => k.loading)
    },
    bls: {},
    query(...v) {
        const q = k => {
            const o = walletStore.bls[k];
            if (!o || o.loading) return;
            o.loading = 1;
            walletStore.bls = {...walletStore.bls};
            const isMain = k === 'main';
            if(!isMain)return o.loading=0;
            getData(
                isMain ? '@balance' : '@thirdBalance',
                isMain ? undefined : {product_id: k},
                (r) => {
                    const {balance, available} = r;
                    o.balance = +available || +balance;
                    o.loading = 0;
                    walletStore.bls = {...walletStore.bls}
                },
                (e) => {
                    o.loading = 0;
                    walletStore.bls = {...walletStore.bls}
                },
            );
        };
        if (v && v.length !== 0) {
            v.forEach(q)
        } else {
            Object.keys(walletStore.bls).forEach(q)
        }
    },
    load() {
        const {wallets} = thirdStore;
        const o = {};
        ['main'].concat(wallets).forEach(k => {
            const v = (o[k] = (this.bls || {})[k] || {
                id: k,
                loading: 0,
                balance: 0,
            });
            let ld = () => this.query(k)
            Object.defineProperty(v, 'load', {
                enumerable: true,
                configurable: true,
                get: () => ld,
                set: v => ld = v
            })
            v.name = this.name(k);
            v.loading = 0
        });
        try {
            this.bls = {...o}
        } catch (e) {
        }
        return this;
    }
})
